/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-03-07 13:31:56
 * @LastEditTime: 2022-04-01 10:53:48
 * @FilePath: \insurforce-backstage-platform-side\src\views\order\homeManage\request.js
 */
import request from '@/utils/request';
export function orderList(data) {
  return request.post('admin/order/list', data);
}
export function downloadOrder(data) {
  return request.post('admin/order/download', data);
}
export function orderDetail(data) {
  return request.post('admin/order/detail', data);
}
// 订单添加
export function orderStoreCase(data) {
  return request.post('admin/order/store-case', data);
}
// 订单添加
export function getTags(data) {
  return request.post('admin/order/getTags', data);
}
export const PAYSTATUS = [{
  key: 1,
  value: '已支付'
}, {
  key: 2,
  value: '已退款'
}, {
  key: 3,
  value: '部分退款'
}, {
  key: 4,
  value: '待支付'
}, {
  key: 5,
  value: '取消支付'
}, {
  key: 6,
  value: '退款失败'
}, {
  key: 7,
  value: '已失效'
}, {
  key: 8,
  value: '退款中'
}];